var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2C1C5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#53389E",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 27.4999L27 29.4999L31.5 24.9999M36 27.9999C36 32.9083 30.646 36.4783 28.698 37.6147C28.4766 37.7439 28.3659 37.8085 28.2097 37.842C28.0884 37.868 27.9116 37.868 27.7903 37.842C27.6341 37.8085 27.5234 37.7439 27.302 37.6147C25.354 36.4783 20 32.9083 20 27.9999V23.2175C20 22.418 20 22.0182 20.1308 21.6746C20.2463 21.371 20.434 21.1001 20.6777 20.8854C20.9535 20.6423 21.3278 20.5019 22.0764 20.2212L27.4382 18.2105C27.6461 18.1326 27.75 18.0936 27.857 18.0782C27.9518 18.0644 28.0482 18.0644 28.143 18.0782C28.25 18.0936 28.3539 18.1326 28.5618 18.2105L33.9236 20.2212C34.6722 20.5019 35.0465 20.6423 35.3223 20.8854C35.566 21.1001 35.7537 21.371 35.8692 21.6746C36 22.0182 36 22.418 36 23.2175V27.9999Z",
    stroke: "#9E77ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.a536331fa4c85680110e517a1f80c65b.svg";
export { ForwardRef as ReactComponent };